var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "#B4975A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4975A",
    d: "M18.304 8.184c-.453.2-.939.336-1.45.397a2.531 2.531 0 0 0 1.11-1.396c-.488.289-1.028.499-1.603.612A2.525 2.525 0 0 0 12.06 10.1a7.167 7.167 0 0 1-5.202-2.638 2.523 2.523 0 0 0 .781 3.37 2.513 2.513 0 0 1-1.144-.315v.031c0 1.224.87 2.244 2.025 2.476a2.525 2.525 0 0 1-1.14.043 2.527 2.527 0 0 0 2.358 1.753A5.065 5.065 0 0 1 6 15.865 7.14 7.14 0 0 0 9.87 17c4.643 0 7.182-3.847 7.182-7.183 0-.11-.002-.218-.007-.327.493-.355.92-.8 1.26-1.306"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2fadc75269da485c46f1022e00b701f2.svg";
export { ForwardRef as ReactComponent };